import { React, useState, useEffect } from "react";
import styled from "styled-components";
import AlertCard from "./AlertCard";

const AlertsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`

const NoAlerts = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    background: #eef7f0;

    .icon {
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #1e7d3c;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 1;
    }

    .title {
        font-weight: 600;
        font-size: 14px;
        color: #1e7d3c;
    }

    .sub {
        font-weight: 400;
        font-size: 13px;
        color: #4d8a5f;
    }
`

const TFGMLink = styled.a`
    align-self: flex-start;
    margin-top: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #0d0c1d;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`

const Spinner = styled.div`
    align-self: center;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #c41306;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;

const Alerts = ({ tramstop }) => {
    const [stopName, setStopName] = useState(tramstop);
    const [travelUpdates, setTravelUpdates] = useState([]);
    const [loading, setLoading] = useState(false);

    const travelUpdateTFGMLink = "https://tfgm.com/travel-updates/travel-alerts"

    useEffect(() => { 
        setStopName(tramstop) 
    }, [tramstop]);


    useEffect(() => {
        setTravelUpdates([]);
        setLoading(true); // Set loading to true when fetching starts

        let tramStopName = stopName?.name;
        var formattedStopName = tramStopName?.replaceAll("\n", " ");
        formattedStopName = formattedStopName === "Deansgate- Castlefield" ? "Deansgate-Castlefield" : formattedStopName; // TODO: REMOVE THIS HACK FIX

        fetch("/updates/" + formattedStopName)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((travelUpdates) => {
                setTravelUpdates(travelUpdates);
            })
            .catch((error) => {
                console.error("Error fetching travel update content: ", error);
            })
            .finally(() => {
                setLoading(false); // Set loading to false when fetching is complete
            });
    }, [stopName]);


    return (
        <AlertsSection>
            {loading ? ( // Show spinner while loading
                <Spinner />
            ) : travelUpdates.length > 0 ? (
                travelUpdates.map((alert, index) => (
                    <AlertCard key={index} passedAlert={alert} />
                ))
            ) : (
                <NoAlerts>
                    <span className="icon">✓</span>
                    <span>
                        <span className="title">No travel alerts.</span><br />
                        <span className="sub">Service running as normal.</span>
                    </span>
                </NoAlerts>
            )}
            <TFGMLink href={travelUpdateTFGMLink} target="_blank" rel="noreferrer">
                View all updates on TFGM →
            </TFGMLink>
        </AlertsSection>
    )
};

export default Alerts;
